import { render } from "./PreApprovalStep3.vue?vue&type=template&id=33517bbc&scoped=true"
import script from "./PreApprovalStep3.vue?vue&type=script&lang=js"
export * from "./PreApprovalStep3.vue?vue&type=script&lang=js"

import "./PreApprovalStep3.vue?vue&type=style&index=0&id=33517bbc&lang=scss&scoped=true"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33517bbc"]])

export default __exports__